var Emphasis;
(function (Emphasis) {
    Emphasis["xLow"] = "xLow";
    Emphasis["low"] = "low";
    Emphasis["medium"] = "medium";
    Emphasis["high"] = "high";
})(Emphasis || (Emphasis = {}));
export default Emphasis;
